import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '~redux/hooks';
import combinedActions from '~redux/combinedActions';
import { TUpdateStockOutStatusReduxParams } from '~types/feat/approval';
import { ModuleEnum, PermissionsEnum } from '~utils/enums';
import UtilFunctions from '~utils/functions';
import Table from '~components/molecules/Table';
import ActionButton from '~components/atoms/ActionButton';
import * as Styles from './_stockOutApprovalTable.module.scss';

const StockOutApprovalTable = () => {
    const dispatch = useAppDispatch();

    const { Misc: { dateTimeFormat } } = UtilFunctions;

    const stockOutListing = useAppSelector(state => state.approval.pendingStockOutListing.data);
    const isLoading = useAppSelector(state => state.approval.loadings.getPendingStockOutListing);
    const access = useAppSelector(state => state.auth.userDetails.access);
    const hasEditAccess = access
        .find(item => item.permission === PermissionsEnum.Edit)
        ?.modules.find(module => module === ModuleEnum.Approval);

    const setTempUpdateStockOutState = (data: TUpdateStockOutStatusReduxParams) =>
        dispatch(combinedActions.approvalSetTempUpdateStockOutState(data));

    const setConfirmModalIsOpen = (open: boolean) =>
        dispatch(combinedActions.approvalSetConfirmUpdateStockOutStatusModalIsOpen(open));

    const handleApproveClick = (id: number) => {
        setTempUpdateStockOutState({ id, status: 2 });
        setConfirmModalIsOpen(true);
    };

    const handleRejectClick = (id: number) => {
        setTempUpdateStockOutState({ id, status: 3 });
        setConfirmModalIsOpen(true);
    };

    useEffect(() => {
        dispatch(combinedActions.approvalGetPendingStockOutListingAttempt());
    }, []);

    const tableHeader = [
        'PRODUCT NAME',
        'SERIAL NO.',
        'BRANCH CODE',
        'BRANCH NAME',
        'CUSTOMER NAME',
        'CIF NO.',
        'METAL TYPE',
        'DATE',
        'ACTION',
    ];

    const renderActionButton = (id: number, status: number) => {
        if (status === 1) {
            return (
                <div className={Styles['action-button-container']}>
                    {hasEditAccess && (
                        <ActionButton
                            label='Approve'
                            onClick={() => handleApproveClick(id)}
                            className={`${Styles['action-button']} ${Styles.approve}`}
                        />
                    )}
                    {hasEditAccess && (
                        <ActionButton
                            label='Reject'
                            onClick={() => handleRejectClick(id)}
                            className={`${Styles['action-button']} ${Styles.reject}`}
                        />
                    )}
                </div>
            );
        }
        return '-';
    };

    const tableBody = stockOutListing.map(item => {
        const {
            id,
            productName,
            serialNo,
            branchCode,
            branchName,
            customerName,
            CIFNo,
            metalType,
            status,
            createdAt,
        } = item;

        return [
            productName,
            serialNo,
            branchCode,
            branchName,
            customerName || '-',
            CIFNo || '-',
            metalType || '-',
            dateTimeFormat(createdAt),
            renderActionButton(id, status),
        ];
    });

    return (
        <Table
            header={tableHeader}
            body={tableBody}
            isLoading={isLoading}
        />
    );
};

export default StockOutApprovalTable;
